/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import NewsletterModel from 'cio/models/newsletter';
import EnvironmentService from 'cio/services/environment';
import SubscriptionCenterService from 'cio/services/subscription-center';
import DS from 'ember-data';

interface NewslettersSendingOptionsSummaryArgs {
  model: NewsletterModel;
}

export default class NewslettersSendingOptionsSummary extends Component<NewslettersSendingOptionsSummaryArgs> {
  @service environment!: EnvironmentService;
  @service store!: DS.Store;
  @service subscriptionCenter!: SubscriptionCenterService;

  get isFutureTense() {
    return this.args.model.sending;
  }
}
